
import axios from 'axios';
import { LLMRTEResponse } from '../../types/llm';

export const getRTEResults = async (
  premise: string,
  hypothesis: string
) => {
  return await axios
    .post<LLMRTEResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/rte`,
      {
        premise: premise,
        hypothesis: hypothesis,
      }
    )
    .then((response) => {
      return response.data;
    });
};
